import React from "react";

// "Actions" card: Cancel (always available) and optional submit button.
// The Create Journey button is removed: places are added and saved incrementally.
export default function AddJourneyActions({ canManage, permissionsLoading, submitting, onCancel, submitLabel = null, busyLabel = "Saving…" }) {
  const blocked = permissionsLoading || !canManage;
  const busy = Boolean(submitting);
  const denyTitle = !permissionsLoading && !canManage ? "You do not have permission to save journeys" : undefined;

  return (
    <div className="tsp-card">
      <h4 className="tsp-section-nav-title">Actions</h4>
      <div className="tsp-quick-actions-list">
        <button type="button" className="tsp-btn tsp-btn-outline-primary tsp-quick-action-full" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
        {submitLabel && (
          <button type="submit" className="tsp-btn tsp-btn-success tsp-quick-action-full" disabled={blocked || busy} title={denyTitle}>
            {busy ? busyLabel : submitLabel}
          </button>
        )}
      </div>
      {!permissionsLoading && !canManage && (
        <p className="tsp-preview-note tsp-preview-note-warn" role="status">
          You do not have permission to save journeys.
        </p>
      )}
    </div>
  );
}
